// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StaticPage_wrapper__kfPdL","wrapperHeader":"StaticPage_wrapperHeader__px2_o","wrapperDescription":"StaticPage_wrapperDescription__LhrX_"};